import { render, staticRenderFns } from "./FilterMetric.vue?vue&type=template&id=ffbdd986&scoped=true"
import script from "./FilterMetric.vue?vue&type=script&lang=js"
export * from "./FilterMetric.vue?vue&type=script&lang=js"
import style0 from "./FilterMetric.vue?vue&type=style&index=0&id=ffbdd986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbdd986",
  null
  
)

export default component.exports